import { useState } from "react";
import { LineBoxContainer } from "../../pages/UserLog/UserLog";
import CalendarLineBtn from "./CalendarLineBtn";
import CalendarModal from "../Modal/CalendarModal";

interface CalendarModalBtnProps {
  calendar: {
    value: string;
    initValue: string;
    minWidth?: number;
    disabled?: boolean;
  };
  modal: {
    dateValue?: string;
    changeEvent: (date: string) => void;
    isAllSelectable?: boolean;
    isFutureDisable?: boolean;
    isAfterStartDate?: boolean;
    isFutureDisableFromToday?: boolean;
    isTodayDisable?: boolean;
    isAfter?: {
      value: number;
      unit: string;
    };
    indefiniteOption?: {
      enabled: boolean;
      label?: string;
      value?: string;
    };
  };
}

export default function CalendarModalBtn({
  calendar,
  modal,
}: CalendarModalBtnProps) {
  const [dateClick, setDateClick] = useState(false);

  return (
    <LineBoxContainer>
      <CalendarLineBtn
        onClickEvent={() => setDateClick(true)}
        value={calendar?.value}
        initValue={calendar?.initValue}
        minWidth={calendar?.minWidth}
        disabled={calendar?.disabled}
      />

      {dateClick && (
        <CalendarModal
          closeEvent={() => setDateClick(false)}
          changeEvent={(date: string) => modal.changeEvent(date)}
          dateValue={modal?.dateValue}
          isAllSelectable={modal?.isAllSelectable}
          isFutureDisable={modal?.isFutureDisable}
          isAfterStartDate={modal?.isAfterStartDate}
          isFutureDisableFromToday={modal?.isFutureDisableFromToday}
          isTodayDisable={modal?.isTodayDisable}
          isAfter={modal?.isAfter}
          indefiniteOption={modal?.indefiniteOption}
        />
      )}
    </LineBoxContainer>
  );
}
